/**
 * @description 操作base Factory
 * @author: 菩萨蛮
 * @date 2020/9/29 9:36 上午
 * @version V1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 */

import { json2List, initObject, list2baseItemObj } from './utils';


export default class OperateFactory {
  constructor(json) {
    this.init(json);
  }

  init(json) {
    this.json = json;
    this.list = json2List(json);
    this.qxClassList = {
      obj: Object.create(null),
      dataObj: Object.create(null),
      baseItemObj: Object.create(null),
      valueObj: Object.create(null)
    };
  }

  setDataListItem() {
    const { obj, dataObj, baseItemObj, valueObj } = this.qxClassList;
    this.list.filter(e => e.qxClassType === 'list').forEach(e => {
      obj[`${e.param}List`] = e.qxJson;
    });
    Object.keys(obj).forEach(key => {
      const json = obj[key];
      const list = json2List(json);
      // TODO 这里要放一个校验函数
      dataObj[key] = initObject(list);
      baseItemObj[key] = list2baseItemObj(list);
      valueObj[key] = [];
    });
  }


  /**
   * 柯里化的创建初始化data的方法
   * @returns any
   */
  initData() {
    const data = {
      dataObj: initObject(this.list),
      baseItemObj: list2baseItemObj(this.list)
    };
    this.setDataListItem();
    return {
      ...data,
      qxList: {
        dataObj: this.qxClassList.dataObj,
        baseItemObj: this.qxClassList.baseItemObj,
        value: this.qxClassList.valueObj
      }
    };
  }
}
